export function validarCampos (regras, dados) {
  const listaDeErros = {}
  for (const { campo, validacoes } of regras) {
    const valor = obterValorPorCaminho(dados, campo)
    if (valor === undefined) {
      continue
    }

    for (const { mensagem, validar } of validacoes) {
      if (!validar(valor)) {
        listaDeErros[campo] = mensagem
        break
      }
    }
  }

  const dadosValidos = Object.values(listaDeErros).length === 0
  return {
    erro: !dadosValidos,
    listaDeErros: listaDeErros
  }
}

function obterValorPorCaminho (obj, caminho) {
  return caminho.split('.').reduce((acc, parte) => acc && acc[parte], obj)
}
